import React, { useEffect, useState } from 'react';
import ClayLayout from "@clayui/layout";
import ClayButton from "@clayui/button";
import BitnamiFilterCardContent from './BitnamiFilterCardContent.es';
import { OFFERING_IMAGES } from '../../../constants/bitnamiHome/bitnamiHomeConstants.es';

const BitnamiFilters = ({ constructStackCategoryCardHref, fetchAppsPayload, setFetchAppsPayload, isPreviewMode }) => {
    const cardList = [
        {
            title: "Single-Tier",
            category: "On the Cloud",
            path: "cloud",
            icon: "onCloudIcon",
        },
        // decommision the multitier
        // {
        //     title: "Multi Tier",
        //     category: "On the Cloud",
        //     path: "multitier",s
        //     icon: "onCloudIcon",
        // },
        {
            title: "Docker",
            category: "Containers",
            path: "containers",
            icon: "containerIcon",
        },
        {
            title: "Kubernetes",
            category: "Helm charts",
            path: "helm",
            icon: "containerIcon",
        },
        {
            title: "Virtual Machines",
            category: "On my computer",
            path: "virtual-machine",
            icon: "myComputerIcon",
        },
    ];
    const [activeCard, setActiveCard] = useState(null);

    useEffect(() => {
        const url = new URL(window.location.href);
        const params = new URLSearchParams(url.search);
        const stack = params.get('stack');

        if (stack) {
            setActiveCard(stack);
        }
    }, []);

    const handleCardClick = (path) => {
        setActiveCard(path);
        updateStack(path, true);
        setFetchAppsPayload({ ...fetchAppsPayload, tags: '', searchText: '', offerings: OFFERING_IMAGES[path] });
    };

    return (
        <ClayLayout.Row justify="start">
            <ClayLayout.Col size={isPreviewMode === "true" ? 12 : 10}>
                <ClayLayout.Row>
                    {
                        cardList.map((card) => (
                            <ClayLayout.Col size={12}
                                sm={6}
                                md={4}
                                lg={3}
                                xl={2}
                                className='mb-1'
                                key={card.path}
                            >
                                {activeCard === card.path ? (
                                    <span className={`card-nav-link btn btn-unstyled ${activeCard === card.path ? 'active-card' : ''}`}>
                                        <BitnamiFilterCardContent card={card} />
                                    </span>
                                ) : (
                                    <a data-senna-off className="card-nav-link btn btn-unstyled" type="button" href={constructStackCategoryCardHref(card.path, true)}>
                                        <BitnamiFilterCardContent card={card} />
                                    </a>
                                )}
                            </ClayLayout.Col>
                        ))
                    }
                </ClayLayout.Row>
            </ClayLayout.Col>
        </ClayLayout.Row>
    );
};

export default BitnamiFilters;